import AuthService from '../service/auth-service'
import ApiHttp from '../http';

export default class Interceptors {

    constructor(AxiosInstance) {

        /**
         *
         * @returns {*}
         * @private
         */
        this._httpInstance = ()=> {
            return AxiosInstance;
        };

        this.interceptors = {
            request: [],
            response: [],
        };

        this.in_flight_requests = {length: 0};
    }

    request(config) {
        if (!AuthService.authToken() && !(config.url ==ApiHttp.defaults.baseURL + AuthService._tokenRequestUri)) {
            let error = new Error('No Session Token for user')
            error.response = {
                config: config,
                data: {error: {code: 'SESSION_TOKEN:NO_TOKEN'}}
            };

            throw error;
        }

        config.headers['Authorization'] = 'Bearer' + AuthService.authToken();
        config.headers['X-SESSION'] = AuthService.authToken();
        config.headers["Accept"] = "application/json, text/html, text/plain, */*"
        this.in_flight_requests.length++;
        return config
    }

    response(response) {
        this.in_flight_requests.length--;
        return response;
    }

    responseError(error) {

        this.in_flight_requests.length--;
        try {
            var reason = error.response.data.error.code;
        } catch (e) { }

        switch (reason) {
            case 'SESSION_TOKEN:NO_TOKEN':
            case 'SESSION_TOKEN:EXPIRED':
            case 'SESSION_TOKEN:INVALID':
            case 'SESSION_TOKEN:USER_NOT_FOUND':
                this.in_flight_requests.length++;
                return AuthService.retrieveAuthToken()
                    .then(() => {
                            this.in_flight_requests.length--;
                            return ApiHttp.request(error.response.config);// replay the request
                        },
                        (error) => {
                            this.in_flight_requests.length--;
                        });
                break;

        }

        var errorResponse = error;
            if(errorResponse.response && errorResponse.response.data ){
                errorResponse.response.data = errorResponse.response.data.data || errorResponse.data;
                errorResponse.response.success = errorResponse.response.success || false;
            }

        return Promise.reject(errorResponse);
    }

    registerRequestInterceptors() {
        this.interceptors.request.push(this._httpInstance().interceptors.request.use(this.request.bind(this)));
    }

    registerResponseInterceptors() {
        this.interceptors.response.push(this._httpInstance().interceptors.response.use(this.response.bind(this), this.responseError.bind(this)));
    }

    stopRequests() {
        for (var i = 0; i < this.interceptors.request.length; i++) {
            var interceptor = this.interceptors.request[i];
            this._httpInstance().interceptors.request.eject(interceptor);
        }
        return true;
    }

    stopResponse() {
        for (var i = 0; i < this.interceptors.response.length; i++) {
            var interceptor = this.interceptors.response[i];
            this._httpInstance().interceptors.response.eject(interceptor);
        }
        return true;
    }

    stopInterceptors() {
        return this.stopRequests() && this.stopResponse()
    }

    static start(AxiosInstance) {
        var instance = new Interceptors(AxiosInstance);
        instance.registerRequestInterceptors();
        instance.registerResponseInterceptors();
        return instance;
    }

    static stop(InterceptorInstance) {
        return InterceptorInstance.stopInterceptors();
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/http/Interceptors.js